/** Auto-refresh interval for subscription events dashboard. */
export const SUBSCRIPTION_EVENT_REFETCH_INTERVAL_MS = 30_000;

export const SUBSCRIPTION_EVENT_DEFAULT_LIMIT = 50;

export const SUBSCRIPTION_EVENT_TYPES = [
  'trial_started',
  'trial_expired',
  'subscription_created',
  'subscription_activated',
  'subscription_renewed',
  'subscription_expired',
  'subscription_cancelled',
  'payment_pending',
  'payment_paid',
  'payment_failed',
  'payment_rejected',
  'entitlement_granted',
  'entitlement_revoked',
] as const;

export type SubscriptionEventType = (typeof SUBSCRIPTION_EVENT_TYPES)[number];

export const SUBSCRIPTION_EVENT_SOURCES = [
  'website',
  'super_admin',
  'myfatoorah',
  'instapay',
  'system',
  'platform',
] as const;

export type SubscriptionEventSource = (typeof SUBSCRIPTION_EVENT_SOURCES)[number];

export const TRIAL_EVENT_TYPES: SubscriptionEventType[] = ['trial_started', 'trial_expired'];

export const SUBSCRIPTION_EVENT_TYPE_NAMES: SubscriptionEventType[] = [
  'subscription_created',
  'subscription_activated',
  'subscription_renewed',
  'subscription_expired',
  'subscription_cancelled',
];

export const PAYMENT_EVENT_TYPES: SubscriptionEventType[] = [
  'payment_pending',
  'payment_paid',
  'payment_failed',
  'payment_rejected',
];

export const ENTITLEMENT_EVENT_TYPES: SubscriptionEventType[] = [
  'entitlement_granted',
  'entitlement_revoked',
];

export const SUBSCRIPTION_EVENT_QUERY_KEYS = {
  history: (query: Record<string, string | number>) =>
    ['subscription-events', 'history', query] as const,
  analytics: ['subscription-events', 'analytics'] as const,
};
